import React, { useCallback, useRef, useState } from 'react'
import { Col, Form, Row, Table } from 'react-bootstrap';
import TBody from './TBody';
import THead from './THead';
import "./style.scss";
import { Trans } from 'react-i18next';
import Pagination from 'react-js-pagination';

export default function({
  columns, 
  data, 
  pagination={},
  isLoading=false,
  dataToExport=false,
  expandRow=null,
  expandRowColumns=null,
  handlePageChange=()=>{},
  handlePerPageChange=()=>{},
  handleSearchChange=()=>{},
  onlyTable=false
}){

  const [page, setPage] = useState(1);
  const timeOutSearchRef = useRef(null);

  const changePage = useCallback((page)=>{
    setPage(page)
    handlePageChange(page)
  },[]);

  if(dataToExport) return (
    <Table>
      <THead columns={columns}/>
      <TBody columns={columns} data={data} dataToExport expandRow={expandRow} expandRowColumns={expandRowColumns}/>
    </Table>
  )

  if(onlyTable){
    return (
      <Table hover responsive="sm">
        <THead columns={columns} isExpandRow={!!expandRow}/>
        <TBody columns={columns} data={data} isLoading={isLoading} expandRow={expandRow} expandRowColumns={expandRowColumns}/>
      </Table>
    )
  }

  return (
    <div className="new-table">
      <Row className="justify-content-between">
        <Col xs="auto">
          <Form.Group>
            <Form.Label>Registros por página:</Form.Label>
            <Form.Control
              as="select"
              size="sm"
              onChange={(e) => {
                let value = e.target.value;
                handlePerPageChange(value)
              }}
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col xs="auto">
          <Form.Group>
            <Form.Label>Pesquisar:</Form.Label>
            <Form.Control
              size="sm"
              onChange={(e) => {
                let value = e.target.value;
                if (timeOutSearchRef.current) {
                  clearTimeout(timeOutSearchRef.current);
                }
                timeOutSearchRef.current = setTimeout(() => {
                  handleSearchChange(value)
                }, 500);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Table hover responsive="sm">
            <THead columns={columns} isExpandRow={!!expandRow}/>
            <TBody columns={columns} data={data} isLoading={isLoading} expandRow={expandRow} expandRowColumns={expandRowColumns}/>
          </Table>
        </Col>
      </Row>
      <Row className="new-table-pagination justify-content-between">
        <Col xs="auto">
          <Trans i18nKey="label:interpolateShowingRecords">
            Showing {{ from: pagination.from || '0' }} to{' '}
            {{ to: pagination.to || '0' }} from{' '}
            {{ total: pagination.total }} records
          </Trans>
        </Col>
        <Col xs="auto" className="d-flex justify-content-end">
          <Pagination
            activePage={page}
            itemsCountPerPage={pagination.per_page}
            totalItemsCount={parseInt(pagination.total)}
            onChange={changePage}
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="‹"
            nextPageText="›"
          />
        </Col>
      </Row>
    </div>
  );
};